module.exports = __webpack_public_path__ + "dff049ab3aeb6e0ef2f849e9c05bef8e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/fedex_2_2023_chart.png
// module id = 1677
// module chunks = 0